export const QuickInterviewGetters = {
  quickInterview: state => state.quickInterview,
  quickInterviewsList: state => state.quickInterviewsList,
  quickInterviewsSteps: state => state.quickInterviewsSteps,
}
